import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import RepairBudgetList from './components/LongRepairPlanList';

const { Cell } = ResponsiveGrid;

const RepairBudget = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="長期修繕計劃列表"
        breadcrumbs={[
          {
            name: '長期修繕計劃',
          },
          {
            name: '長期修繕計劃列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <RepairBudgetList />
    </Cell>
  </ResponsiveGrid>
);

export default RepairBudget;
